// extracted by mini-css-extract-plugin
export default {"deliveryWindowFeeInput":"delivery-window-fee_deliveryWindowFeeInput__LGRdo"};